import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToElement } from '~/utils/helpers';
import ScreenTabsNavigation from '~/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import BranchesManagementHeader from '~/view/screens/BranchesManagementScreen/components/BranchesManagementHeader/BranchesManagementHeader';
import HoursProfileBranches from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/components/HoursProfileBranches/HoursProfileBranches';
import HoursProfileList from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/components/HoursProfileList/HoursProfileList';
import ProfileHours from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/components/ProfileWorkingHours/ProfileWorkingHours';
import SimplifiedTimeControl from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/components/SimplifiedTimeControl/SimplifiedTimeControl';
import { branchesWorkingHoursStore } from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/store/branchesWorkingHoursStore';

const BranchesWorkingHours = observer(() => {
  const { state } = useLocation<{ id: number | undefined }>();

  useEffect(() => {
    const runEffect = async () => {
      await branchesWorkingHoursStore.getProfiles(1);

      if (state?.id) {
        await branchesWorkingHoursStore.getProfile(state.id);
        scrollToElement({ id: `profile_${state.id}` });
      }
    };

    runEffect();

    return () => {
      branchesWorkingHoursStore.clear();
    };
  }, []);

  return (
    <>
      <BranchesManagementHeader>
        {({ navigation }) => (
          <div className="d-flex justify-content-between pr-4 mb-3">
            <ScreenTabsNavigation options={navigation} showSoloOption />
            <SimplifiedTimeControl />
          </div>
        )}
      </BranchesManagementHeader>
      <div className="d-flex flex-1">
        <HoursProfileList />
        <HoursProfileBranches />
        <ProfileHours key={branchesWorkingHoursStore.selectedProfile?.id} />
      </div>
    </>
  );
});

export default BranchesWorkingHours;
